import React from 'react';
// Ganti isi <svg> di bawah ini dengan SVG icon custom Anda.
// Pastikan ukuran viewBox="0 0 24 24" agar konsisten dengan icon lain.
export function PaketIcon(props) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
      {/* Contoh isi SVG, silakan ganti dengan SVG Anda */}
      <rect x="3" y="7" width="18" height="13" rx="2" fill="#4F8EF7"/>
      <rect x="7" y="3" width="10" height="4" rx="1" fill="#A7C7F9"/>
    </svg>
  );
} 